import { Analytics } from '@vercel/analytics/react';

export function VercelAnalytics() {
  return <Analytics />;
}
